import isEmpty from 'lodash.isempty';
import get from 'lodash.get';
import actionTypes from '../constants/action-types';
import siteLocalesConstants from '../../site-locales/constants/common';

const blockPreview = (state = {}, action) => {
  if (action.type !== actionTypes.INITIALIZE_BLOCK) return state;
  if (state.id !== action.payload.blockId) return state;

  if (state.variations) return state;

  const { htmlLocale } = action.payload;
  const preview =
    get(state, `previews[${htmlLocale}]`) ||
    get(state, `previews[${siteLocalesConstants.DEFAULT_SITE_LOCALE}]`);

  if (isEmpty(preview)) return state;

  return {
    ...state,
    preview,
  };
};

export default blockPreview;
